import {AxiosError, AxiosResponse} from "axios"
import {get} from "lodash"

export default function is401(err: AxiosError) {
  return get(err, "response.status") === 401
}

export function isGraph401(res: AxiosResponse) {
  const useErrorHandler = get(res, "config.useErrorHandler", true)
  let found = false
  if (useErrorHandler && res.data) {
    if (Array.isArray(res.data.errors)) {
      res.data.errors.forEach(({statusCode}: any) => {
        if (statusCode === 401) {
          found = true
        }
      })
    }
  }

  if (res.status === 401) {
    found = true
  }

  return found
}
